// extracted by mini-css-extract-plugin
export default {"element":"styles_element__QA6d2","horizontal":"styles_horizontal__3eY-M"};